// helper/textFilter.js
const normalizeTr = (s = "") =>
  s.toLocaleLowerCase("tr").replace(/\s+/g, " ").trim();

const textFilterForNakliyeHesaplama = (options, searchText, key) => {
  const query = normalizeTr(searchText || "");
  if (!query) return options;

    const tokens = query.split(/[\/\s]+/).filter(Boolean);

    return options.filter((item) => {
      const city = normalizeTr(item.city || "");
      const town = normalizeTr(item.town || "");
      const location = normalizeTr(item[key] || ""); // genelde "location"
      const pair1 = `${town}/${city}`;
      const pair2 = `${city}/${town}`;
      const haystack = [
        city,
        town,
        location,
        pair1,
        pair2,
        `${town} ${city}`,
        `${city} ${town}`,
      ]
        .join(" ")
        .trim();

      // Tek kelimeyse startsWith öncelikli
      if (tokens.length === 1) {
        const t = tokens[0];
        const starts =
          town.startsWith(t) ||
          city.startsWith(t) ||
          location.startsWith(t) ||
          pair1.startsWith(t) ||
          pair2.startsWith(t);

        if (starts) return true;
        return haystack.includes(t);
      }

      // Çok kelimede: tüm tokenlar herhangi bir sırada geçmeli
      return tokens.every((t) => haystack.includes(t));
    });
};

export default textFilterForNakliyeHesaplama
